import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import { Currency } from 'components/_basic/Currency/Currency';
import { FieldTableContainer } from 'components/_basic/Form/FieldTableContainer';
import { FormTable } from 'components/_basic/Form/FormTableComponent';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FormSectionFilledCard } from 'components/_basic/FormSectionFilledCard';
import { FullScreenWrapper } from 'components/BusinessToolForm/Sections/FinancialPlan/components/FullScreenWrapper';

import { defaultColumns } from './constants';
import { IEachUnitTableProps } from './types';
import { EachUnitErrorMessage } from '../EachUnitErrorMessage';
import { EachUnitTotal } from '../EachUnitTotal';

import styles from './EachUnitTable.module.scss';

const FIRST_COLUMN_WIDTH = 250;
const FIRST_COLUMN_LENGTH = 150;

export const EachUnitTable: FC<IEachUnitTableProps> = ({
  name,
  fields,
  columns,
  disabled,
  watchColumnTitleName,
  onRemoveRow,
  onInsertRow,
  scrollToElement,
}) => {
  const { t } = useTranslation();

  const [hasError, setHasError] = useState(false);

  const getDefaultColumnTitle = (index: number) => t('product/ServiceWithBreak', { index: index + 1 });

  const handleErrorStateChange = (error: boolean) => setHasError(error);
  return (
    <FormSectionCard
      collapsible
      disabled={disabled}
      title={t('financialPlan.plannedExpenses.costOfEachUnit.tableDescription')}
    >
      <FullScreenWrapper title={t('financialPlan.plannedExpenses.costOfEachUnit.tableDescription')} disabled={disabled}>
        <Currency />
        <Box className={styles.container}>
          <FieldTableContainer>
            <FormSectionFilledCard>
              <FormTable
                name={name}
                rows={fields}
                columns={columns}
                disabled={disabled}
                firstColumnWidth={FIRST_COLUMN_WIDTH}
                firstColumnLength={FIRST_COLUMN_LENGTH}
                watchColumnTitleName={watchColumnTitleName}
                defaultColumns={defaultColumns}
                getDefaultColumnTitle={getDefaultColumnTitle}
                onRemoveRow={onRemoveRow}
                onInsertRow={onInsertRow}
                notAllowedToDeleteRowIndexes={[0, 1]}
                needToConvertToNegative
              />

              <EachUnitTotal
                name={name}
                firstColumnWidth={FIRST_COLUMN_WIDTH}
                columns={columns}
                disabled={disabled}
                onErrorStateChange={handleErrorStateChange}
                scrollToElement={scrollToElement}
              />
            </FormSectionFilledCard>
          </FieldTableContainer>
        </Box>
        {hasError && <EachUnitErrorMessage scrollToElement={scrollToElement} />}
      </FullScreenWrapper>
    </FormSectionCard>
  );
};
